<template>
    <div class="details-header">
        <div class="details-header-content">
            <div class="details-header-content-title">
                {{ title }}
            </div>
            <div class="details-header-content-subtitle">
                {{ subTitle }}
            </div>
        </div>

        <div class="details-header-actions">
            <DeleteProduct :product="product" />
        </div>
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { computed, defineComponent, PropType } from 'vue';
    import { MainProduct } from '@shared/interfaces/product';
    import {
        ActivityProduct,
        FerryProduct,
        FlightProduct,
        HotelProduct,
        ProductType,
    } from '@/api/Cart/cart.interfaces';
    import DeleteProduct from '@/components/checkoutPageV3/Shared/DeleteProduct/DeleteProduct.vue';

    export default defineComponent({
        name: 'ProductDetailsHeader',
        methods: { t },
        components: { DeleteProduct },
        props: {
            product: {
                type: Object as PropType<MainProduct>,
                required: true,
            },
        },
        setup({ product }) {
            const title = computed(() => {
                switch (product.Type) {
                    case ProductType.Hotel:
                        return t({ key: 'shared.accommodation_product' });
                    case ProductType.Flight:
                        return t({ key: 'shared.flight_product' });
                    case ProductType.Ferry:
                        return t({ key: 'shared.ferry_product' });
                    case ProductType.Activity:
                        return t({ key: 'shared.activity_product' });
                    default:
                        return '';
                }
            });

            const subTitle = computed(() => {
                switch (product.Type) {
                    case ProductType.Hotel:
                        return t({
                            prefix: `${(product as HotelProduct).Rooms.length} `,
                            key: 'shared.room',
                            keyPlural: 'shared.rooms',
                            count: (product as HotelProduct).Rooms.length,
                        });
                    case ProductType.Flight:
                        return t({
                            prefix: `${(product as FlightProduct).Pax.length} `,
                            key: 'shared.ticket',
                            keyPlural: 'shared.tickets',
                            count: (product as FlightProduct).Pax.length,
                        });
                    case ProductType.Ferry:
                        return t({
                            prefix: `${(product as FerryProduct).Pax.length} `,
                            key: 'shared.ticket',
                            keyPlural: 'shared.tickets',
                            count: (product as FerryProduct).Pax.length,
                        });
                    case ProductType.Activity:
                        return t({
                            prefix: `${(product as ActivityProduct).Tickets.length} `,
                            key: 'shared.ticket',
                            keyPlural: 'shared.tickets',
                            count: (product as ActivityProduct).Tickets.length,
                        });
                    default:
                        return '';
                }
            });

            return { title, subTitle };
        },
    });
</script>

<style lang="scss">
    @forward 'ProductDetailsHeader.scss';
</style>
